import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-304" data-mp="rrp8ibgwjnl2">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-305" data-mp="wr25vq5egd1w">
        <FadeIn data-id="element-306" data-mp="wt669y43atxf">
          <div className="space-y-2 md:space-y-4" data-id="element-307" data-mp="3v97gciwoculh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-308" data-mp="3vaijcgiapybj">
              <span className="text-sm md:text-base" data-id="element-309" data-mp="e0u7flcnaas1">🎨</span>
              <span className="text-[8.5px]" data-id="element-310" data-mp="e2f2rd6s9xqy">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[30px] md:text-[56px] leading-[1.08] tracking-[0.5px] text-txt-primary mx-auto max-w-[20ch] px-2 pt-3 pb-1" data-id="element-311" data-mp="1kj8vm6gmdlsc">
              <span className="block" data-id="element-312" data-mp="1h9sia9chfmxh">TODO LO QUE NECESITAS</span>
              <span className="block text-brandGold" data-id="element-313" data-mp="1cazc71ziyy7c">EN COLORIMETRÍA</span>
              <span className="block" data-id="element-314" data-mp="189m92znth944">LISTO. DESDE HOY</span>
            </h1>

            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-315" data-mp="18bqh9tsr0ua7">
              15 Módulos en Video · 4 Manuales Profesionales · 5 Bonos · Curso Completo
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-316" data-mp="tjooetp3j1jo">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-317" data-mp="tjez78bvkyf1">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-318" data-mp="omofmb0v3kov"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-319" data-mp="kl2yuel7im9e"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[300px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-320" data-mp="fjnc8i3ds7ow" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-321" data-mp="3s3rgnrvb47qq">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-322" data-mp="3s52r2aj9cdqt">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-323" data-mp="jqu5hmf5kn85">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-324" data-mp="opx1yih2hl4i">
                <span className="text-[10px] md:text-xs" data-id="element-325" data-mp="evy25q4gudfq">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-326" data-mp="17e211cms4hwz">
                <span className="text-[10px] md:text-xs" data-id="element-327" data-mp="2n5xh591zra34">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-328" data-mp="31utr5bnlyx6d">
                <span className="text-[10px] md:text-xs" data-id="element-329" data-mp="296xuu81yb7a4">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-330" data-mp="2i6tbuti6twi2">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-331" data-mp="2i4glbryd6dte">
                🎨 DOMINA LA COLORIMETRÍA AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-332" data-mp="3tk5a8ov6hmwu">
                <span className="flex items-center gap-1" data-id="element-333" data-mp="op6t52ywrjs9">
                  <ShieldCheck size={11} className="text-success" data-id="element-334" data-mp="oqq9suoh7wuk" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-335" data-mp="ssbsiwnoz5co">
                  <Lock size={11} className="text-txt-muted" data-id="element-336" data-mp="xoty1yquj7q2" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-337" data-mp="12phk0607wydf">
                  <CreditCard size={11} className="text-brandGold" data-id="element-338" data-mp="17o16c7iq4c6b" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos dominan con esto'
  }, {
    value: '15',
    label: 'Módulos en video'
  }, {
    value: '4',
    label: 'Manuales PDF'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-339" data-mp="1vef32bc96z78">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-340" data-mp="3fvei230e5fha">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-341" data-mp="3fw61kfgprmr7">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-342" data-mp="3av0bkpefudld" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-343" data-mp="35y9tjwj2p7xb">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-344" data-mp="2gi4apwbn22t">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-345" data-mp="3to44g8ju0mex" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'No sabía como realizar platinados. Con esto aprendí como hacerlos. Me ayudo mucho, gracias.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Implemente el servicio de color con mi equipo. Ahora realizamos trabajos completos. Sin errores.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Descargué todo el curso. Ahora lo aplicamos en el local. Me ayudo mucho a comprender qué fórmula usar.',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-346" data-mp="1rzq3aofcta2u">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-347" data-mp="1vzqlmk5kq5f6">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-348" data-mp="1i092akb1rkd7" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-349" data-mp="1i1siyc0m7xfi">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-350" data-mp="3ccywl35buvl4">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-351" data-mp="3cbdzp6vjj0k3">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-352" data-mp="10q57fox4cq3r">
                  <div className="flex text-gold mb-0.5" data-id="element-353" data-mp="10r6ku01lxoon">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-354" data-mp="1ff9rlbnh54ei" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-355" data-mp="1ao1cq03dkqty">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-356" data-mp="1jgmvvhax4zjb">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-357" data-mp="1yd43bxfzlu0l">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-358" data-mp="3z2wapaaa0pf">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const UniqueMechanism = () => {
  const scattered = ['Buscaste videos en YouTube.', 'Seguiste tutoriales en Instagram.', 'Preguntaste a otros barberos.', 'Todos te enseñaron algo diferente.'];
  const chain = [{
    from: 'Diagnóstico claro',
    to: 'Fórmula exacta'
  }, {
    from: 'Fórmula exacta',
    to: 'Aplicación paso a paso'
  }, {
    from: 'Aplicación',
    to: 'Resultado garantizado'
  }];
  return <Section className="bg-bg-base" data-id="element-359" data-mp="2qggymu7prf9z">
      <div className="max-w-[880px] mx-auto" data-id="element-360" data-mp="2vcfhy3e6q73j">
        <FadeIn data-id="element-361" data-mp="2vfbepoeaqpqe">
          <h2 className="font-display font-bold uppercase text-[22px] md:text-[36px] leading-[1.2] tracking-[0.5px] text-center text-txt-primary mb-8 md:mb-12" data-id="element-362" data-mp="30cbjzx3bnogg">
            🔍 ¿POR QUÉ <span className="text-brandGold" data-id="element-363" data-mp="34f8a08v6ymuf">FALLAS</span> EN
            COLORIMETRÍA?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-stretch" data-id="element-364" data-mp="fofdd3svquxv">
          {/* The scattered way */}
          <FadeIn data-id="element-365" data-mp="2468i7ue0t03g">
            <div className="h-full rounded-[18px] border border-line bg-bg-card p-5 md:p-7" data-id="element-366" data-mp="244nmw2jvtd4j">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] text-danger mb-4" data-id="element-367" data-mp="203ve1aex9a8s">
                Cómo aprendiste hasta hoy
              </p>
              <ul className="space-y-2.5 mb-5" data-id="element-368" data-mp="1qekae3at0xsa">
                {scattered.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-369" data-mp="1qchj7fxx0ylz">
                    <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-danger" aria-hidden="true" data-id="element-370" data-mp="1lgseyzayatjc" />
                    <span className="font-sans text-[13.5px] md:text-[15px] leading-[1.5] text-txt-body" data-id="element-371" data-mp="1getf3zef6er5">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="flex flex-wrap gap-1.5 mb-4" data-id="element-372" data-mp="17hj1i7e4qdj2">
                {['Decoloración aquí', 'Fórmulas allá', 'Técnicas en otro lado'].map(piece => <span key={piece} className="rounded-md border border-dashed border-danger/40 bg-danger/5 px-2 py-1 font-sans text-[11px] md:text-[12px] text-txt-muted" data-id="element-373" data-mp="31sxserivmj0e">
                    {piece}
                  </span>)}
              </div>

              <p className="font-sans font-bold text-[14px] md:text-[16px] leading-[1.5] text-txt-primary mb-3" data-id="element-374" data-mp="dc20wpgk83ve">
                Cuando los juntaste... no encajaron.
              </p>
              <p className="font-sans text-[13px] md:text-[14.5px] leading-[1.5] text-danger" data-id="element-375" data-mp="mejlkzgkgoga">
                Improvisación · Dudas · Cabello quemado · Cliente decepcionado
              </p>
            </div>
          </FadeIn>

          {/* The system */}
          <FadeIn delay={0.1} data-id="element-376" data-mp="8d758mxhuktv">
            <div className="h-full rounded-[18px] border-2 border-brandGold bg-bg-card p-5 md:p-7 shadow-[0_0_45px_rgba(212,162,76,0.16)]" data-id="element-377" data-mp="8eij5fknl8yp">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] text-brandGold mb-3" data-id="element-378" data-mp="3knsfs6mrtq4">
                La verdad
              </p>
              <p className="font-display font-bold uppercase text-[17px] md:text-[22px] leading-[1.25] tracking-[0.5px] text-txt-primary mb-2" data-id="element-379" data-mp="372pizijvnt5m">
                No necesitas más técnicas aisladas.
              </p>
              <p className="font-sans text-[13.5px] md:text-[15px] leading-[1.55] text-txt-body mb-5" data-id="element-380" data-mp="1rdg5d7cp8qau">
                Necesitas{' '}
                <span className="font-bold text-brandGold" data-id="element-381" data-mp="1ijusxuo0bl4l">UN SISTEMA</span>{' '}
                donde cada paso conecta con el siguiente:
              </p>

              <ol className="space-y-2.5 mb-5" data-id="element-382" data-mp="269xedrxf1su8">
                {chain.map(step => <li key={step.from} className="flex items-center gap-2 rounded-[12px] border border-brandGold/25 bg-brandGold/5 px-3 py-2.5" data-id="element-383" data-mp="2abamk8nze84b">
                    <CheckCircle2 size={15} className="text-success shrink-0" aria-hidden="true" data-id="element-384" data-mp="1wazretfn27dc" />
                    <span className="font-sans font-bold text-[12.5px] md:text-[14px] text-txt-primary leading-snug" data-id="element-385" data-mp="218hxmc29u8hn">
                      {step.from}
                    </span>
                    <ArrowRight size={14} className="text-brandGold shrink-0" aria-hidden="true" data-id="element-386" data-mp="pvz0511k6dd3" />
                    <span className="font-sans text-[12.5px] md:text-[14px] text-txt-body leading-snug" data-id="element-387" data-mp="5rrps5ziqh97">
                      {step.to}
                    </span>
                  </li>)}
              </ol>

              <p className="font-sans font-bold uppercase tracking-[1px] text-[12px] md:text-[13px] text-brandGold mb-4" data-id="element-388" data-mp="3t4kk4qfaoht6">
                Sin huecos. Sin dudas. Sin improvisar.
              </p>

              <div className="border-t border-line pt-4" data-id="element-389" data-mp="3j9iuzul0rfql">
                <p className="font-sans text-[13.5px] md:text-[15px] leading-[1.55] text-txt-body" data-id="element-390" data-mp="3e8d0psbpnkey">
                  Eso es lo que hacen los{' '}
                  <span className="font-bold text-txt-primary" data-id="element-391" data-mp="3a7jcexucw3lj">
                    +500 barberos
                  </span>{' '}
                  que dominan la colorimetría.
                </p>
                <p className="font-display font-bold uppercase text-[18px] md:text-[24px] tracking-[0.5px] text-brandGold mt-1" data-id="element-392" data-mp="18fee94m9ka2d">
                  Eso es el Megapack.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Aprendiste técnicas, fórmulas o trabajos complejos buscando videos por tu cuenta', 'No tienes UN SISTEMA donde sepas EXACTAMENTE cómo mezclar, decolorar y neutralizar sin arruinar el cabello', 'Repites los mismos trabajos porque no tienes un banco completo de diseños y técnicas organizadas', 'Un cliente nuevo pide un "platinado blanco" y no sabes que tintura utilizar exactamente', 'Conoces sobre el tema, pero no lo dominas realmente por falta de confianza', 'Cada mes pierdes ingresos extras por rechazar trabajos o cobrarlos a un precio que no es rentable'];
  return <Section className="bg-bg-alt" data-id="element-393" data-mp="162kkboo6m42w">
      <div className="max-w-[720px] mx-auto" data-id="element-394" data-mp="2df35bklcvy31">
        <FadeIn data-id="element-395" data-mp="2de1k4namlv7l">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-396" data-mp="2dejo663j5dq2">
            Si trabajas en <span className="text-brandGold" data-id="element-397" data-mp="2g0aj5tf924zq">barbería o peluquería,</span>
            <br data-id="element-398" data-mp="2b0o6bl3c2qrg" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-399" data-mp="2b2iq2w2vccty">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-400" data-mp="2pvcc70cnbr7l" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-401" data-mp="2yxllxo03bgjx" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-402" data-mp="2tz0gna5ze6om">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-403" data-mp="33p3miay7bf4d"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-404" data-mp="3dnjba79racap">
            ¿Sigues perdiendo clientes{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-405" data-mp="558vg7er3pso">
             por tener un conocimiento disperso?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-406" data-mp="3sbt3dt6rhycb">
            <p style={{
            paddingLeft: "10px"
          }} data-id="element-407" data-mp="3dizdddtv5zte">
              Elegiste este camino porque amas esta profesión, trabajar en la imagen de tus
              clientes y ganar dinero en serio.
            </p>
            <p style={{
            paddingLeft: "9px"
          }} data-id="element-408" data-mp="34ib1aoo169j5">
              Pero nadie te dijo que ibas a pasar años buscando el curso ideal, sin
              encontrar UN SISTEMA donde TODO esté organizado, donde NO FALLES y
              donde DOMINES realmente la colorimetría.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-409" data-mp="155uh31tyb5ku">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-410" data-mp="wciiyfgxyj4g">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-411" data-mp="1o3om74rykwxy">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-412" data-mp="1k2l7illnd6yb"></div>
        </FadeIn>
      </div>
    </Section>;
};